<script setup lang="ts">
import { useStylesStore } from '@/stores';
import { computed } from 'vue';
const store = useStylesStore();
const logo = computed(() => store.logo);
</script>
<template>
    <img :src="logo" alt="logo" />
</template>
